import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type OfflineState = {
  isOnline: boolean;
  pendingCount: number;
  failedCount: number;   // items permanently failed (retry_count >= MAX_RETRY), need export
};

const initialState: OfflineState = {
  isOnline: true,
  pendingCount: 0,
  failedCount: 0,
};

const offlineSlice = createSlice({
  name: 'offline',
  initialState,
  reducers: {
    setOnlineStatus(state, action: PayloadAction<boolean>) {
      state.isOnline = action.payload;
    },
    setPendingCount(state, action: PayloadAction<number>) {
      state.pendingCount = action.payload;
    },
    setFailedCount(state, action: PayloadAction<number>) {
      state.failedCount = action.payload;
    },
  },
});

export const { setOnlineStatus, setPendingCount, setFailedCount } = offlineSlice.actions;
export { offlineSlice };
